import { gql } from "@apollo/client";
import { MEMBER_INFO } from "../fragments";

export const LOGIN = gql`
  mutation loginAdmin($username: String!, $password: String!, $code: String!) {
    loginAdmin(username: $username, password: $password, code: $code) {
      user {
        username
      }
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;

export const RESET_MEMBER_PASSWORD = gql`
  mutation resetMemberPassword(
    $member: ID!
    $newPassword: String!
    $username: String!
  ) {
    resetMemberPassword(
      member: $member
      newPassword: $newPassword
      username: $username
    ) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const RESET_MEMBER_WITHDRAW_PASSWORD = gql`
  mutation resetWithdrawPassword($member: ID!, $password: String!) {
    resetWithdrawPassword(member: $member, password: $password) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export const REQUEST_OTP = gql`
  mutation requestOtp($username: String!) {
    requestOtp(username: $username)
  }
`;
